var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.351562,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#050050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8.35156C13 11.113 10.7614 13.3516 8 13.3516C5.23858 13.3516 3 11.113 3 8.35156C3 5.59014 5.23858 3.35156 8 3.35156C10.7614 3.35156 13 5.59014 13 8.35156ZM14 8.35156C14 11.6653 11.3137 14.3516 8 14.3516C4.68629 14.3516 2 11.6653 2 8.35156C2 5.03785 4.68629 2.35156 8 2.35156C11.3137 2.35156 14 5.03785 14 8.35156ZM8.5 4.75156C8.5 4.47542 8.27614 4.25156 8 4.25156C7.72386 4.25156 7.5 4.47542 7.5 4.75156V8.35156C7.5 8.48417 7.55268 8.61135 7.64645 8.70512L8.84645 9.90512C9.04171 10.1004 9.35829 10.1004 9.55355 9.90512C9.74882 9.70985 9.74882 9.39327 9.55355 9.19801L8.5 8.14446V4.75156Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconDark);
export default __webpack_public_path__ + "static/media/clockIconDark.78cd94f5715e754e5d2c45fb28771fda.svg";
export { ForwardRef as ReactComponent };